module.exports = __webpack_public_path__ + "img/756.0e2b6415.png";